<template>
  <div :class="classDiv">
    <img
      ref="imagen"
      src="@/assets/img/iconos/postulacion-abierta.svg"
      :style="styleImg"
      :class="classImg"
      v-if="postulacion === 'ABIERTA'"
    />
    <img
      ref="imagen"
      src="@/assets/img/iconos/postulacion-cerrada.svg"
      :style="styleImg"
      :class="classImg"
      v-if="postulacion === 'CERRADA'"
    />
    <img
      ref="imagen"
      src="@/assets/img/iconos/lista-espera.svg"
      :style="styleImg"
      :class="classImg"
      v-if="postulacion === 'LISTA_DE_ESPERA'"
    />
    <b-tooltip
      :disabled.sync="tooltipDisabled"
      :target="() => $refs['imagen']"
      :title="textoToolTip"
    ></b-tooltip>
  </div>
</template>

<script>
export default {
  name: "PostulacionTP",
  props: {
    postulacion: { type: String },
    tooltipDisabled: { type: Boolean, default: false },
    styleImg: { type: String },
    classImg: { type: String },
    classDiv: { type: String }
  },
  computed: {
    textoToolTip() {
      switch (this.postulacion) {
        case "ABIERTA":
          return 'Postulaciones abiertas'
          break;
        case "CERRADA":
          return 'Postulaciones cerradas'
          break;
        case "LISTA_DE_ESPERA":
          return 'Postulaciones en lista de espera';
          break;
        default:
          break;
      }
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/generales/iconos/PostulacionTP.vue